import script from "./InvestigationGeneralHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./InvestigationGeneralHeader.vue?vue&type=script&setup=true&lang=js"

import "./InvestigationGeneralHeader.vue?vue&type=style&index=0&id=6ae4b321&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ae4b321"]])

export default __exports__